import { useMemo } from 'react';
import { useQuery } from '@apollo/client';

import { GetUserById } from '@resources/users.graphql';
import { useSession } from '@common/contexts/session';

export const useGetUserInfo = () => {
  const { currentUser: currentSessionUser, licensedApplications } = useSession();
  const { userId: currentUserId } = currentSessionUser;

  const { data: userData } = useQuery(GetUserById, {
    variables: { id: currentUserId }
  });

  const users = userData?.users;

  const { lastName, firstName, firstLast, username } = useMemo(
    () => users?.find(user => user.userId === currentUserId) || {},
    [users, currentUserId]
  );

  const displayName = `${lastName}, ${firstName}`;

  return {
    currentUserId,
    displayName,
    firstLast,
    licensedApplications,
    username
  };
};
